import Axios from 'axios';

var headers = {
    'Content-Type': 'application/json',


}


export default {

    getAll() {
        const BASE_URL = '/public/api';
        return Axios.get(BASE_URL+ '/ledgeracc',{ headers: headers });
    },
    add(data) {
        const BASE_URL = '/public/api';
        return Axios.post(BASE_URL+ '/ledgeracc', data,{ headers: headers });
    },

    update(data) {
        const BASE_URL = '/public/api';
        return Axios.put(BASE_URL+ '/ledgeracc/'  +data.id, data,{ headers: headers });
    },

    delete(id) {
        const BASE_URL = '/public/api';
        return Axios.delete(BASE_URL  + '/ledgeracc/'+ id,{ headers: headers });
    }

}
